import { Link, Box, Typography } from "@mui/material";
import React from "react";

const entryStyle = {
  fontFamily: "Montserrat",
  width: "75%",
  "@media (max-width: 1500px)": {
    width: "100%",
  },
  weight: "100%",
  color: "white",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  padding: "10px",
  "& img": {
    maxWidth: "100%",
    maxHeight: "100%",
  },
};

function NewlineText({ text }) {
  return text.split("\n").map((str, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <span key={index}>
      {str}
      {index !== text.split("\n").length - 1 && <br />}
    </span>
  ));
}

export default function BlogEntry({ entry }) {
  return (
    <Box sx={entryStyle}>
      <Typography
        fontFamily="Montserrat"
        fontWeight="Light"
        variant="h5"
        gutterBottom
      >
        {entry.title}
      </Typography>
      <img src={entry.image} alt={entry.title} />
      <Typography
        fontFamily="Montserrat"
        fontWeight="Light"
        variant="subtitle1"
        gutterBottom
      >
        {entry.description}
      </Typography>
      <Typography fontFamily="Montserrat" fontWeight="Light" variant="body1">
        <NewlineText text={entry.content} />
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: "20px",
        }}
      >
        {entry.links &&
          entry.links.map((link) => (
            <Link
              key={link.id}
              sx={{
                position: "relative",
                color: "white",
                textDecorationColor: "white",
                transition: "color 0.25s ease-in-out",
                "&:hover": {
                  color: "gray",
                },
              }}
              target="_blank"
              href={link.url}
            >
              {link.displayText}
            </Link>
          ))}
      </Box>
    </Box>
  );
}
